import type ExtendedPropertyUri from 'owa-service/lib/contract/ExtendedPropertyUri';
import { getExtendedPropertyUri } from 'owa-service/lib/ServiceRequestUtils';

/** Extended property that holds a flag to check if the user is a presenter in the event */
export const IsPresenterExtendedProperty: ExtendedPropertyUri = getExtendedPropertyUri(
    '00020329-0000-0000-C000-000000000046',
    'IsPresenter',
    'Boolean'
);
